import React, { useState, useEffect } from "react";

const ProductBanner = ({ headerBanner }) => {
  const targetTime = new Date(headerBanner?.countdown_1);
  const [timeRemaining, setTimeRemaining] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const [isCountdownComplete, setIsCountdownComplete] = useState(false);
  useEffect(() => {
    const updateCountdown = () => {
      const currentTime = new Date();
      const timeDifference = targetTime - currentTime;

      if (timeDifference > 0) {
        const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor(
          (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
        );
        const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

        setTimeRemaining({ days, hours, minutes, seconds });
      } else {
        setTimeRemaining({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        setIsCountdownComplete(true)
        clearInterval(interval);
      }
    };

    const interval = setInterval(updateCountdown, 1000);

    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  }, [targetTime]);
  const lines = headerBanner?.discount_description?.split('*');//start for spliting setances

  return (
    <>
      {headerBanner?.buy_more_banner &&!(window.Shopify?.country=="CA")&& (
        <div className="product__banner">
          <div className="product__banner__contents">
            <p className="banner_title">{headerBanner.headline_1}</p>
            <div className="product__banner__description_box">
              <div className="banner__wrapper">
                <div className="discount-block">
                  <div className="discount-value">
                    {headerBanner.percent_off_1}
                  </div>
                  <div className="discount-label">
                    ${headerBanner.spend_amt_1}+
                  </div>
                </div>
                <div className="discount-block">
                  <div className="discount-value">
                    {headerBanner.percent_off_2}
                  </div>
                  <div className="discount-label">
                    ${headerBanner.spend_amt_2}+
                  </div>
                </div>
                <div className="discount-block">
                  <div className="discount-value">
                    {headerBanner.percent_off_3}
                  </div>
                  <div className="discount-label">
                    ${headerBanner.spend_amt_3}+
                  </div>
                </div>
              </div>
            </div>
            {!isCountdownComplete ?
            <div className=" product__banner__wrapper">
              <div className="time-block">
                <div className="time-count">{timeRemaining.days}</div>
                <div className="time-label">days</div>
              </div>
              <div className="time-block">
                <div className="time-count">{timeRemaining.hours}</div>
                <div className="time-label">hours</div>
              </div>
              <div className="time-block">
                <div className="time-count">{timeRemaining.minutes}</div>
                <div className="time-label">mins</div>
              </div>
              <div className="time-block">
                <div className="time-count">{timeRemaining.seconds}</div>
                <div className="time-label">secs</div>
              </div>
            </div>:<div className=" product__banner__wrapper">
            <div className="time-label"> {headerBanner.post_countdown_message}</div></div>}
            
          </div>
        </div>
      )}
      {headerBanner?.birthday_sale_banner && !(window.Shopify?.country=="CA")&& (
        <div className="product__banner">
          <div className="product__banner__contents">
            <p className="banner_title">{headerBanner.headline_1}</p>
            <div className="product__banner__description_box">
              <div class="discount-label">
                Use code <span>{headerBanner.discount_code}</span> at checkout
              </div>
            </div>
            {!isCountdownComplete ?
            <div className=" product__banner__wrapper">
              <div className="time-block">
                <div className="time-count">{timeRemaining.days}</div>
                <div className="time-label">days</div>
              </div>
              <div className="time-block">
                <div className="time-count">{timeRemaining.hours}</div>
                <div className="time-label">hours</div>
              </div>
              <div className="time-block">
                <div className="time-count">{timeRemaining.minutes}</div>
                <div className="time-label">mins</div>
              </div>
              <div className="time-block">
                <div className="time-count">{timeRemaining.seconds}</div>
                <div className="time-label">secs</div>
              </div>
            </div>:<div className=" product__banner__wrapper">
            <div className="time-label"> {headerBanner.post_countdown_message}</div></div>}
          </div>
        </div>
      )}
      {headerBanner?.embroidery_sale_banner && !(window.Shopify?.country=="CA")&& (
        <div className="product__banner">
          <div className="product__banner__contents">
            <p className="banner_title">{headerBanner.headline_1}</p>
            <div className="product__banner__description_box">
              <div class="discount-label">
                {lines?.map((line, index) => (
                  <p key={index}>{line.trim()}</p>
                ))}
              </div>
              <div class="discount-label">{headerBanner.text_block}</div>
            </div>
            {!isCountdownComplete ?
            <div className=" product__banner__wrapper">
              <div className="time-block">
                <div className="time-count">{timeRemaining.days}</div>
                <div className="time-label">days</div>
              </div>
              <div className="time-block">
                <div className="time-count">{timeRemaining.hours}</div>
                <div className="time-label">hours</div>
              </div>
              <div className="time-block">
                <div className="time-count">{timeRemaining.minutes}</div>
                <div className="time-label">mins</div>
              </div>
              <div className="time-block">
                <div className="time-count">{timeRemaining.seconds}</div>
                <div className="time-label">secs</div>
              </div>
            </div>:<div className=" product__banner__wrapper">
            <div className="time-label"> {headerBanner.post_countdown_message}</div></div>}
          </div>
        </div>
      )}
      {headerBanner?.mothers_day_banner && !(window.Shopify?.country=="CA")&& (
        <div className="product__banner">
          <div className="product__banner__contents">
            <p className="banner_title">{headerBanner.headline_1}</p>
            <div className="product__banner__description_box">
              <div className="banner__wrapper">
                <div class="discount-block">
                  <div class="discount-value">
                    {headerBanner.delivery_date_1}
                  </div>
                  <div class="discount-label">
                    {headerBanner.delivery_type_1}
                  </div>
                </div>
                <div class="discount-block">
                  <div class="discount-value">
                    {headerBanner.delivery_date_2}
                  </div>
                  <div class="discount-label">
                    {headerBanner.delivery_type_2}
                  </div>
                </div>
                <div class="discount-block">
                  <div class="discount-value">
                    {headerBanner.delivery_date_3}
                  </div>
                  <div class="discount-label">
                    {headerBanner.delivery_type_3}
                  </div>
                </div>
              </div>
            </div>
            <div className=" product__banner__wrapper">
              {headerBanner.fineprint_1}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProductBanner;
